import SafeImage from '@/components/SafeImage';

const carouselItems = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20battlefield%20at%20sunset%20with%20armies%20facing%20off%2C%20dramatic%20sky%20with%20golden%20clouds%2C%20cinematic%20widescreen%20composition%2C%20historical%20epic%20film%20aesthetic%2C%20warm%20amber%20and%20crimson%20tones%2C%20no%20text&width=1000&height=600&seq=carousel-01&orientation=landscape',
    tag: '专题合集',
    title: '史诗巨制 · 不可错过的历史大片',
    desc: '从秦汉到明清，十部制作精良的历史题材影视作品，带你穿越千年时空。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20cozy%20rainy%20night%20scene%20through%20a%20window%20with%20warm%20interior%20light%2C%20books%20and%20tea%20on%20a%20wooden%20table%2C%20soft%20ambient%20lighting%2C%20comforting%20atmosphere%2C%20cinematic%20composition%2C%20introspective%20mood%2C%20warm%20golden%20tones&width=1000&height=600&seq=carousel-02&orientation=landscape',
    tag: '编辑精选',
    title: '雨夜观影 · 最适合一个人静静品味的影片',
    desc: '窗外雨声淅沥，窝在沙发里看一部走心的电影，这是最好的周末夜晚。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20cityscape%20with%20cherry%20blossoms%20and%20warm%20sunset%20sky%2C%20whimsical%20fantasy%20elements%2C%20colorful%20detailed%20background%2C%20Japanese%20animation%20aesthetic%2C%20dreamy%20atmosphere%2C%20cinematic%20widescreen&width=1000&height=600&seq=carousel-03&orientation=landscape',
    tag: '动漫专场',
    title: '二次元盛宴 · 年度最值得看的动画番剧',
    desc: '从热血战斗到治愈日常，本年度评分最高的动画作品一次集齐。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=A%20couple%20dancing%20in%20a%20vintage%20ballroom%20with%20sparkling%20chandeliers%2C%20elegant%20attire%2C%20romantic%20warm%20lighting%2C%20soft%20focus%20background%2C%20classic%20romance%20film%20aesthetic%2C%20dreamy%20atmosphere%2C%20cinematic%20composition&width=1000&height=600&seq=carousel-04&orientation=landscape',
    tag: '甜蜜剧场',
    title: '甜到犯规 · 让人心跳加速的恋爱剧合集',
    desc: '从校园初恋到都市情缘，精选十部高甜度爱情剧，帮你找回心动的感觉。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Dark%20futuristic%20city%20with%20holographic%20advertisements%20and%20flying%20cars%2C%20cyberpunk%20aesthetic%2C%20neon%20orange%20and%20deep%20blue%20contrasting%20lights%2C%20rain%20slicked%20streets%2C%20sci-fi%20cinematic%20atmosphere%2C%20widescreen&width=1000&height=600&seq=carousel-05&orientation=landscape',
    tag: '科幻之旅',
    title: '未来已来 · 最具想象力的科幻电影精选',
    desc: '人工智能、星际旅行、平行宇宙……这些科幻佳作将彻底打开你的脑洞。',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20forest%20with%20a%20single%20figure%20holding%20a%20lantern%2C%20eerie%20atmosphere%2C%20cool%20muted%20tones%20with%20warm%20lantern%20glow%2C%20suspenseful%20cinematic%20composition%2C%20psychological%20thriller%20aesthetic%2C%20no%20text&width=1000&height=600&seq=carousel-06&orientation=landscape',
    tag: '悬疑之夜',
    title: '烧脑不停 · 反转再反转的高分悬疑片',
    desc: '不到最后一秒猜不到结局，这些悬疑神作将挑战你的推理能力极限。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-xl md:text-2xl font-heading text-foreground-900 text-center mb-3">
          焦点专题
        </h2>
        <p className="text-sm md:text-base text-foreground-500 text-center mb-10 md:mb-14 max-w-xl mx-auto">
          精心策划的影视专题，发现属于你的观影方向
        </p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item, idx) => (
            <a
              key={idx}
              href="#cards"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group block bg-background-100 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:bg-background-200/70"
            >
              <div className="relative aspect-[16/10] overflow-hidden">
                <SafeImage
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-sm md:text-base font-heading text-foreground-900 mb-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}